/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { H as index$8 } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import getNetworkType$1 from './dingTalk/index.js';
import getNetworkType$2 from './windvane/index.js';
import getNetworkType$3 from './nebula/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

var apiConfig = {
    web: {
        dingTalk: getNetworkType$1,
        windvane: getNetworkType$2,
        nebula: getNetworkType$3,
    },
};
/**
 * 是获取当前网络状态。
 * 小程序API：https://opendocs.alipay.com/mini/api/network-status
 * @returns {Promise<unknown>} promise调用结果
 *
 * @example
 * import { getNetworkType } from '@alife/cn-uni-api';
 *
 * getNetworkType()
 * .then((res) => {
 *   console.log('success', res);
 * })
 * .catch((error) => {
 *   console.log(error);
 * });
 * @author 敬文
 */
var getNetworkType = extend(apiConfig, index$8);

export { getNetworkType };
